// document.addEventListener("DOMContentLoaded", function () {
//   // Adding plus minus buttons in line-items in cart-drawer
//   var QtyIncDec = class extends HTMLElement {
//     constructor() {
//       super();
//       this.addEventListener("click", this._onQuantityChanged);
//     }
//     _onQuantityChanged(event) {
//       try {
//         if (!event.target.hasAttribute("line-item-key")) {
//           return;
//         }
//         let isPlus = false;
//         if (event.target.classList.contains("button-plus")) {
//           isPlus = true;
//         }
//         const currentQty = event.target.getAttribute("current-quantity");
//         const targetQty = isPlus
//           ? parseInt(currentQty) + 1
//           : parseInt(currentQty) == 1
//           ? 0
//           : parseInt(currentQty) - 1;
//         if (targetQty > 0) {
//           this._changeLineItemQuantity(
//             event.target.getAttribute("line-item-key"),
//             targetQty
//           );
//         } else {
//           this._onRemoveLinkClicked(event);
//         }
//       } catch (error) {
//         console.error("Error in quantity change:", error);
//       }
//     }
//     _onRemoveLinkClicked(event) {
//       try {
//         event.preventDefault();
//         this._changeLineItemQuantity(
//           event.target.getAttribute("line-item-key"),
//           0
//         );
//       } catch (error) {
//         console.error("Error in remove link clicked:", error);
//       }
//     }
//     async _changeLineItemQuantity(lineKey, targetQuantity) {
//       try {
//         if (window.themeVariables.settings.pageType === "cart") {
//           window.location.href = `${Shopify.routes.root}cart/change?id=${lineKey}&quantity=${targetQuantity}`;
//         } else {
//           const lineItem = this.closest("line-item");
//           lineItem?.dispatchEvent(
//             new CustomEvent("line-item:will-change", {
//               bubbles: true,
//               detail: { targetQuantity },
//             })
//           );
//           let sectionsToBundle = [];
//           document.documentElement.dispatchEvent(
//             new CustomEvent("cart:prepare-bundled-sections", {
//               bubbles: true,
//               detail: { sections: sectionsToBundle },
//             })
//           );
//           const cartContent = await (
//             await fetch(`${Shopify.routes.root}cart/change.js`, {
//               method: "POST",
//               headers: {
//                 "Content-Type": "application/json",
//               },
//               body: JSON.stringify({
//                 id: lineKey,
//                 quantity: targetQuantity,
//                 sections: sectionsToBundle,
//               }),
//             })
//           ).json();
//           const lineItemAfterChange = cartContent["items"].filter(
//             (lineItem2) => lineItem2["key"] === lineKey
//           );
//           lineItem?.dispatchEvent(
//             new CustomEvent("line-item:change", {
//               bubbles: true,
//               detail: {
//                 quantity:
//                   lineItemAfterChange.length === 0
//                     ? 0
//                     : lineItemAfterChange[0]["quantity"],
//                 cart: cartContent,
//               },
//             })
//           );
//           document.documentElement.dispatchEvent(
//             new CustomEvent("cart:change", {
//               bubbles: true,
//               detail: {
//                 baseEvent: "line-item:change",
//                 cart: cartContent,
//               },
//             })
//           );
//         }
//       } catch (error) {
//         console.error("Error changing line item quantity:", error);
//       }
//     }
//   };
//   if (!window.customElements.get("qty-inc-dec")) {
//     window.customElements.define("qty-inc-dec", QtyIncDec);
//   }

//   // Cart drawer
//   var RemoveLineItem = class extends HTMLElement {
//     constructor() {
//       super();
//       this.addEventListener("change", this._onQuantityChanged);
//       this.addEventListener("click", this._onRemoveLinkClicked);
//     }
//     _onQuantityChanged(event) {
//       try {
//         if (!event.target.hasAttribute("data-line-key")) {
//           return;
//         }
//         this._changeLineItemQuantity(
//           event.target.getAttribute("data-line-key"),
//           parseInt(event.target.value)
//         );
//       } catch (error) {
//         console.error("Error in _onQuantityChanged:", error);
//       }
//     }
//     _onRemoveLinkClicked(event) {
//       try {
//         event.preventDefault();
//         this._changeLineItemQuantity(
//           event.target.getAttribute("line-item-key"),
//           0
//         );
//       } catch (error) {
//         console.error("Error in _onRemoveLinkClicked:", error);
//       }
//     }
//     async _changeLineItemQuantity(lineKey, targetQuantity) {
//       try {
//         if (window.themeVariables.settings.pageType === "cart") {
//           window.location.href = `${Shopify.routes.root}cart/change?id=${lineKey}&quantity=${targetQuantity}`;
//         } else {
//           const lineItem = this.closest("line-item");
//           lineItem?.dispatchEvent(
//             new CustomEvent("line-item:will-change", {
//               bubbles: true,
//               detail: { targetQuantity },
//             })
//           );
//           let sectionsToBundle = [];
//           document.documentElement.dispatchEvent(
//             new CustomEvent("cart:prepare-bundled-sections", {
//               bubbles: true,
//               detail: { sections: sectionsToBundle },
//             })
//           );
//           const cartContent = await (
//             await fetch(`${Shopify.routes.root}cart/change.js`, {
//               method: "POST",
//               headers: {
//                 "Content-Type": "application/json",
//               },
//               body: JSON.stringify({
//                 id: lineKey,
//                 quantity: targetQuantity,
//                 sections: sectionsToBundle,
//               }),
//             })
//           ).json();
//           const lineItemAfterChange = cartContent["items"].filter(
//             (lineItem2) => lineItem2["key"] === lineKey
//           );
//           lineItem?.dispatchEvent(
//             new CustomEvent("line-item:change", {
//               bubbles: true,
//               detail: {
//                 quantity:
//                   lineItemAfterChange.length === 0
//                     ? 0
//                     : lineItemAfterChange[0]["quantity"],
//                 cart: cartContent,
//               },
//             })
//           );
//           document.documentElement.dispatchEvent(
//             new CustomEvent("cart:change", {
//               bubbles: true,
//               detail: {
//                 baseEvent: "line-item:change",
//                 cart: cartContent,
//               },
//             })
//           );
//         }
//       } catch (error) {
//         console.error("Error in _changeLineItemQuantity:", error);
//       }
//     }
//   };
//   if (!window.customElements.get("remove-line-item")) {
//     window.customElements.define("remove-line-item", RemoveLineItem);
//   }
// });

//optimize script

(function() {
  'use strict';
  const CartUtils = {
    getRoutesRoot() {
      return window.Shopify?.routes?.root || '/';
    },

    isCartPage() {
      return window.themeVariables?.settings?.pageType === 'cart';
    },
 
    dispatch(element, eventName, detail = {}) {
      if (!element) return;
      element.dispatchEvent(new CustomEvent(eventName, {
        bubbles: true,
        detail
      }));
    },
    
    redirectToCartChange(lineKey, quantity) {
      window.location.href = `${this.getRoutesRoot()}cart/change?id=${lineKey}&quantity=${quantity}`;
    },

    async updateCartAjax(lineKey, targetQuantity) {
      const lineItem = document.querySelector(`[line-item-key="${lineKey}"]`)?.closest('line-item');
      
      // Notify that change is starting
      this.dispatch(lineItem, 'line-item:will-change', { targetQuantity });
      
      // Prepare sections to bundle
      const sectionsToBundle = [];
      this.dispatch(document.documentElement, 'cart:prepare-bundled-sections', { 
        sections: sectionsToBundle 
      });
      
      // Make API call
      const response = await fetch(`${this.getRoutesRoot()}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: lineKey,
          quantity: targetQuantity,
          sections: sectionsToBundle
        })
      });
      
      if (!response.ok) {
        throw new Error(`Cart update failed: ${response.status}`);
      }
      
      const cartContent = await response.json();
      
      // Find updated line item
      const updatedLineItem = cartContent.items.find(item => item.key === lineKey);
      const finalQuantity = updatedLineItem ? updatedLineItem.quantity : 0;
      
      // Notify change complete
      this.dispatch(lineItem, 'line-item:change', {
        quantity: finalQuantity,
        cart: cartContent
      });
      
      this.dispatch(document.documentElement, 'cart:change', {
        baseEvent: 'line-item:change',
        cart: cartContent
      });
      
      return cartContent;
    },
 
    async changeQuantity(lineKey, targetQuantity) {
      if (this.isCartPage()) {
        this.redirectToCartChange(lineKey, targetQuantity);
      } else {
        return await this.updateCartAjax(lineKey, targetQuantity);
      }
    }
  };
  
  class CartLineItemBase extends HTMLElement {
    constructor() {
      super();
      this._boundHandlers = new Map();
    }
    
    connectedCallback() {
      this._attachEventListeners();
    }
    
    disconnectedCallback() {
      this._detachEventListeners();
    }
    
    _attachEventListeners() {
      // Override in child classes
    }
    
    _detachEventListeners() {
      this._boundHandlers.forEach((handler, event) => {
        this.removeEventListener(event, handler);
      });
      this._boundHandlers.clear();
    }
    
    _addEventListener(event, handler) {
      const boundHandler = handler.bind(this);
      this._boundHandlers.set(event, boundHandler);
      this.addEventListener(event, boundHandler);
    }
    
    async _handleQuantityChange(lineKey, quantity) {
      try {
        await CartUtils.changeQuantity(lineKey, quantity);
      } catch (error) {
        console.error('Cart update error:', error);
        this._showError('Failed to update cart. Please try again.');
      }
    }
    
    _showError(message) {
      // Can be enhanced with toast notification
      console.error(message);
    }
  }

  class QtyIncDec extends CartLineItemBase {
    _attachEventListeners() {
      this._addEventListener('click', this._handleClick);
    }
    
    _handleClick(event) {
      const target = event.target;
      
      // Only process clicks on buttons with line-item-key
      if (!target.hasAttribute('line-item-key')) return;
      
      const lineKey = target.getAttribute('line-item-key');
      const currentQty = parseInt(target.getAttribute('current-quantity') || '0', 10);
      const isPlus = target.classList.contains('button-plus');
      
      // Calculate target quantity
      let targetQty;
      if (isPlus) {
        targetQty = currentQty + 1;
      } else {
        targetQty = currentQty <= 1 ? 0 : currentQty - 1;
      }
      
      // Update cart
      if (targetQty === 0) {
        this._handleRemove(event, lineKey);
      } else {
        this._handleQuantityChange(lineKey, targetQty);
      }
    }
    
    _handleRemove(event, lineKey) {
      event.preventDefault();
      this._handleQuantityChange(lineKey, 0);
    }
  }

  class RemoveLineItem extends CartLineItemBase {
    _attachEventListeners() {
      this._addEventListener('click', this._handleClick);
      this._addEventListener('change', this._handleChange);
    }
    
    _handleClick(event) {
      const target = event.target;
      
      // Handle remove button clicks
      if (target.hasAttribute('line-item-key')) {
        event.preventDefault();
        const lineKey = target.getAttribute('line-item-key');
        this._handleQuantityChange(lineKey, 0);
      }
    }
    
    _handleChange(event) {
      const target = event.target;
      
      // Handle quantity input changes
      if (target.hasAttribute('data-line-key')) {
        const lineKey = target.getAttribute('data-line-key');
        const newQuantity = parseInt(target.value, 10) || 0;
        this._handleQuantityChange(lineKey, newQuantity);
      }
    }
  }
  
  function registerComponents() {
    if (!customElements.get('qty-inc-dec')) {
      customElements.define('qty-inc-dec', QtyIncDec);
    }
    
    if (!customElements.get('remove-line-item')) {
      customElements.define('remove-line-item', RemoveLineItem);
    }
  }
  
  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', registerComponents);
  } else {
    registerComponents();
  }
  
})();
